<div *ngIf="rect" class="asset-transitioner">
  <div
    class="asset-container"
    [class.opening]="opening"
    [class.closing]="closing"
    [style.top]="rect.y + 'px'"
    [style.left]="rect.x + 'px'"
    [style.width]="rect.width + 'px'"
    [style.height]="rect.height + 'px'"
  >
    <img [src]="url" alt="" [class.fade-away]="fadeOut" #asset />
  </div>
  <div class="transition-asset-bg" *ngIf="showBackgroundIn" [@transitionAssetBgIn]></div>
  <div class="transition-asset-bg" *ngIf="showBackgroundOut" [@transitionAssetBgOut]></div>
</div>
